<template>
  <el-container style="height: 100%;">
    <el-header
      style="
        height: 47px;
        border: 1px solid #d1dbe5;
        padding: 2px;
        border-left-width: 0px;
        border-right-width: 1px;
      "
      ref="menu"
    >
      <top-menu
        @refresh="handleRefresh"
        @new="handleNew"
        @delete="handleDel"
        @cut="handleCut"
        @copy="handleCopy"
        @past="handlePast"
        @ScalChange="handleScale"
        @unset="handleUnset"
        @save="handleSave"
        @print="handlePrint"
        @group="handleGroup"
        @ungroup="handleUnGroup"
        @selectAll="handleSelectAll"
        @selectNone="handleNone"
        @undo="handleUndo"
        @redo="handleRedo"
        @up="handleUp"
        @next="handleNext"
        @alignLeft="handleAlignLeft"
        @alignRight="handleAlignRight"
        @alignTop="handleAlignTop"
        @alignBottom="handleAlignBottom"
        @alignMiddle="handleMiddle"
        @alignCenter="handleCenter"
        @alignVer="handleAlignVer"
        @alignHor="handleAlignHor"
        @equalWidth="handleEqualWidth"
        @equalHeight="handleEqualHeight"
        @equalAll="handleEqualAll"
        @toFont="handleToFont"
        @toBack="handleToBack"
        @entergroup="handleEnterGroup"
        @exitgroup="handleExitGroup"
      ></top-menu>
      <canvas id="qrcode" style="display: none;"></canvas>
      <canvas id="barcode" style="display: none;"></canvas>
    </el-header>
    <el-main style="padding: 0px;">
      <el-container style="height: 100%;">
        <el-aside
          style="
            width: 30px;
            border: 1px solid #d1dbe5;
            padding: 5px;
            border-top-width: 0px;
            border-left-width: 0px;
          "
        >
          <div ref="left_menu" style="height: 5px;"></div>
        </el-aside>
        <el-main :style="{ padding: '0px' }" id="graph_main">
          <div
            tabindex="-2"
            style="box-shadow: #666 0px 0px 10px;"
            :class="{ backGroundImage: showGrid == true }"
            id="graph_container"
            ref="graph_container"
          ></div>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
//加载图形
import QRCode from "qrcode"; //二维码生成控件
import JsBarcode from "jsbarcode"; //一维码控件
import mxgraph from "../../../../../script/initGraphVar";
const {
  mxGraph,
  mxClient,
  mxCodec,
  mxUtils,
  mxConstants,
  mxPerimeter,
} = mxgraph;

var req = mxUtils.load("/script/mxgraph-source/config/shape.xml");
// debugger
var root = req.getDocumentElement();
var shape = root.firstChild;

while (shape != null) {
  if (shape.nodeType == mxConstants.NODETYPE_ELEMENT) {
    mxStencilRegistry.addStencil(
      shape.getAttribute("name"),
      new mxStencil(shape)
    );
  }

  shape = shape.nextSibling;
}

import labelDesignBaseSetting from "./baseSetting";
import Vue from "vue";
Vue.use(labelDesignBaseSetting);
import topMenu from "./component/top-menu.vue";

export default {
  components: {
    topMenu,
  },
  props: {
    porperEvent: Object,
  },
  data() {
    return {
      m_graph: null, //定义一个graph对象用于维护graph对象
      m_toolbar: null, //左侧工具栏
      m_editor: null, //编辑器
      m_tbContainer: null, //工具栏容器
      m_graphContainer: null, //画图主表容器
      cellType: null,
      containerHeight: 0, //画布高度
      qrCodeUrl: "", //二维码生成地址
      barCodeUrl: "", //一维码生成地址
      showGrid: true,
      graph_w: 0,
      graph_h: 0,
      observer: null,
      seletChange: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleRefresh() {
      //刷新界面
      this.m_graph.refresh();
    },
    handleNew() {
      //
      //this.$emit("newGreph", 1);
      if (this.m_graph != undefined) {
        if (this.m_graph.getModel().length > 1) {
          this.$confirm("当前模板不为空，是否确定新建?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.m_graph.removeCells(); //如果确定的话，则清空画布上所有元素
            })
            .catch(() => {});
        }
      } else {
        this._initGraph();
      }
    },
    handleCut() {
      //剪切

      if (this.m_graph.isEnabled()) {
        mxClipboard.cut(this.m_graph);
      }
    },
    handleCopy() {
      if (this.m_graph.isEnabled()) {
        mxClipboard.copy(this.m_graph);
      }
    },
    handlePast() {
      if (this.m_graph.isEnabled()) {
        mxClipboard.paste(this.m_graph);
      }
    },
    handleDel() {
      //删除选中的元素

      if (this.m_graph.isEnabled()) {
        this.m_graph.removeCells();
      } else {
        console.log("未选中");
      }
    },
    handleLarg() {
      //放大
      // this.
      //this.m_graph.zoomIn();
      // this.m_graph.zoomTo(2);
    },
    handleScale(value) {
      this.changeGraphSize(value);
      this.m_graph.zoomTo(value);
      // debugger
    },
    changeGraphSize(value) {
      var mainContainer = $("#graph_main")[0];
      var containerHeight = mainContainer.clientHeight;
      var containerWidth = mainContainer.clientWidth;
      var graphHeight = this.mmConversionPx(this.accMul(this.graph_h, value));
      var graphWidth = this.mmConversionPx(this.accMul(this.graph_w, value));

      var container = $("#graph_container")[0];
      container.style.height = graphHeight + "px";
      container.style.width = graphWidth + "px";
      container.style.marginLeft =
        this.accDiv(this.accSub(containerWidth, graphWidth), 2) + "px";
      container.style.marginTop =
        this.accDiv(this.accSub(containerHeight, graphHeight), 2) + "px";
    },
    handleSmall() {
      //缩小
      this.m_graph.zoomOut();
    },
    handleUnset() {
      //实际大小
      this.m_graph.zoomActual();
    },
    handleSave() {
      let textarea = document.createElement("textarea");
      textarea.style.width = "600px";
      textarea.style.height = "400px";
      let enc = new mxCodec(mxUtils.createXmlDocument());
      let node = enc.encode(this.m_graph.getModel());
      textarea.value = mxUtils.getPrettyXml(node);

      this.showModalWindow("XML", textarea, 410, 440);
      //保存,下载为文件
      const downLink = document.createElement("a");
      downLink.download = "label.xml";
      // 字符内容转换为blod地址
      const xml = mxUtils.getPrettyXml(node);
      const blob = new Blob([xml]);
      downLink.href = URL.createObjectURL(blob);
      // 链接插入到页面
      document.body.appendChild(downLink);
      downLink.click();
      // 移除下载链接
      document.body.removeChild(downLink);
    },
    showModalWindow(title, content, width, height) {
      var background = document.createElement("div");
      background.style.position = "absolute";
      background.style.left = "0px";
      background.style.top = "0px";
      background.style.right = "0px";
      background.style.bottom = "0px";
      background.style.background = "black";
      mxUtils.setOpacity(background, 50);
      document.body.appendChild(background);
      if (mxClient.IS_QUIRKS) {
        new mxDivResizer(background);
      }

      var x = Math.max(0, document.body.scrollWidth / 2 - width / 2);
      var y = Math.max(
        10,
        (document.body.scrollHeight || document.documentElement.scrollHeight) /
          2 -
          (height * 2) / 3
      );
      var wnd = new mxWindow(title, content, x, y, width, height, false, true);
      wnd.setClosable(true);

      // Fades the background out after after the window has been closed
      wnd.addListener(mxEvent.DESTROY, function(evt) {
        mxEffects.fadeOut(background, 50, true, 10, 30, true);
      });

      wnd.setVisible(true);

      return wnd;
    },
    handlePrint() {},
    handleGroup() {
      //组合
      if (this.m_graph.isEnabled()) {
        //页面可编辑的情况下，才允许组合
        this.m_graph.setSelectionCell(this.m_editor.groupCells());
      }
    },
    handleUnGroup() {
      //取消组合
      if (this.m_graph.isEnabled()) {
        this.m_graph.setSelectionCells(this.m_graph.ungroupCells());
      }
    },
    handleSelectAll() {
      //全选
      if (this.m_graph.isEnabled()) {
        this.m_graph.selectAll();
      }
    },
    handleNone() {
      //取消全选
      if (this.m_graph.isEnabled()) {
        this.m_graph.clearSelection();
      }
    },
    handleUndo() {
      if (this.m_graph.isEnabled()) {
        this.m_editor.undo();
      }
    },
    handleRedo() {
      if (this.m_graph.isEnabled()) {
        this.m_editor.redo();
      }
    },
    handleUp() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.selectPreviousCell();
      }
    },
    handleNext() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.selectNextCell();
      }
    },
    handleAlignLeft() {
      //左对齐
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_LEFT);
      }
    },
    handleAlignRight() {
      //右对齐
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_RIGHT);
      }
    },
    handleAlignTop() {
      //顶对齐
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_TOP);
      }
    },
    handleAlignBottom() {
      //顶对齐
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_BOTTOM);
      }
    },
    handleMiddle() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_MIDDLE);
      }
    },

    handleCenter() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.alignCells(mxConstants.ALIGN_CENTER);
      }
    },

    handleAlignVer() {
      //垂直分布
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      if (cells.length < 2) {
        return;
      }
      for (var i = 0; i < cells.length; i++) {
        for (var j = 0; j < cells.length; j++) {
          if (cells[i].geometry.y < cells[j].geometry.y) {
            var h;
            h = cells[i];
            cells[i] = cells[j];
            cells[j] = h;
          }
        }
      }
      var start = cells[0].geometry.y;
      var end = cells[cells.length - 1].geometry.y;
      var span = this.accDiv(this.accSub(end, start), cells.length - 1); //

      for (var k = 1; k < cells.length - 1; k++) {
        cells[k].geometry.y = this.accAdd(start, this.accMul(span, k));
      }
      this.handleRefresh();
      // debugger;
    },

    handleAlignHor() {
      //水平分布
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      if (cells.length < 2) {
        return;
      }
      for (var i = 0; i < cells.length; i++) {
        for (var j = 0; j < cells.length; j++) {
          if (cells[i].geometry.x < cells[j].geometry.x) {
            var h;
            h = cells[i];
            cells[i] = cells[j];
            cells[j] = h;
          }
        }
      }
      var start = cells[0].geometry.x;
      var end = cells[cells.length - 1].geometry.x;
      var span = this.accDiv(this.accSub(end, start), cells.length - 1); //

      for (var k = 1; k < cells.length - 1; k++) {
        cells[k].geometry.x = this.accAdd(start, this.accMul(span, k));
      }
      this.handleRefresh();
    },

    handleEqualWidth() {
      //等宽
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      if (cells.length < 2) {
        return;
      }
      var targetWidth = cells[cells.length - 1].geometry.width;
      for (var i = 0; i < cells.length; i++) {
        cells[i].geometry.width = targetWidth;
      }
      this.handleRefresh();
    },

    handleEqualHeight() {
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      if (cells.length < 2) {
        return;
      }
      var targetHeight = cells[cells.length - 1].geometry.height;
      for (var i = 0; i < cells.length; i++) {
        cells[i].geometry.height = targetHeight;
      }
      this.handleRefresh();
    },

    handleEqualAll() {
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      if (cells.length < 2) {
        return;
      }
      var targetHeight = cells[cells.length - 1].geometry.height;
      var targetWidth = cells[cells.length - 1].geometry.width;
      for (var i = 0; i < cells.length; i++) {
        cells[i].geometry.height = targetHeight;
        cells[i].geometry.width = targetWidth;
      }
      this.handleRefresh();
    },

    handleToFont() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.orderCells(false);
      }
    },

    handleToBack() {
      if (this.m_graph.isEnabled()) {
        this.m_graph.orderCells(true);
      }
    },

    handleEnterGroup() {
      //进入组,创建子图的时候用
      var self = this;
      var cells = this.m_graph.getSelectionCells();
      if (cells.length > 1) {
        self.$message({
          message: "只能进入一个组",
        });
        return;
      } else if (cells.length < 1) {
        self.$message({
          message: "请选择要进入的组",
        });
        return;
      } else {
        var currentCell = cells[0];
        this.m_graph.enterGroup(currentCell);
      }
    },
    handleExitGroup() {
      //退出组

      this.m_graph.exitGroup();
    },
    handleReturn() {
      //退出并行配方显示页面
      // debugger;
      this.$emit("return", 1);
    },
    handleDlgOK(type, data) {
      //弹窗确定事件

      this.m_graph.refresh(cells[0]);
    },
    _initGraph() {
      this.m_tbContainer = this.$refs.left_menu; //左侧菜单
      /* 2019-06-10修正为：将左侧工具栏和主容器放在一个文件里面，因为测试发现，如果采用VUE 常规结构处理，
      需要将作用域传来传去的，还不如直接放在一个页面方便*/
      this.m_toolbar = new mxToolbar(this.m_tbContainer);
      this.m_toolbar.enabled = false; //左侧工具栏
      //销毁工具栏的快捷键事件
      var tb_editor = new mxEditor();
      tb_editor.setGraphContainer(this.m_tbContainer);
      var tb_graph = tb_editor.graph;
      var handler = new mxKeyHandler(tb_graph);
      handler.destroy();

      this.m_graphContainer = this.$refs.graph_container; //主表容器
      this.m_view = this.$refs.graph_container;
      this.m_editor = new mxEditor();
      this.m_graph = this.m_editor.graph;
      this.m_graph.centerZoom = false;

      var self = this;
      this._graphBaseSetLabel(
        self,
        mxClient,
        mxUtils,
        mxConstants,
        mxPerimeter
      );
      this._setGraphSize();
      //背景图片测试
    },
    _setGraphSize(sizeData) {
      var tempSize = {};
      if (sizeData == undefined) {
        tempSize = {
          grid: true, //是否显示网格
          size: 10,
          width: 100,
          height: 70,
          bgColor: "#FFFFFF",
        };
      } else {
        tempSize = sizeData;
      }
      this.m_graph.gridSize = tempSize.size;
      var mainContainer = $("#graph_main")[0];
      var containerHeight = mainContainer.clientHeight;
      var containerWidth = mainContainer.clientWidth;
      var graphHeight = this.mmConversionPx(tempSize.height);
      var graphWidth = this.mmConversionPx(tempSize.width);

      var container = $("#graph_container")[0];
      this.graph_w = tempSize.width; //记录原始标签宽度
      this.graph_h = tempSize.height; //记录原始标签高度
      container.style.height = tempSize.height + "mm";
      container.style.width = tempSize.width + "mm";
      container.style.marginLeft =
        this.accDiv(this.accSub(containerWidth, graphWidth), 2) + "px";
      container.style.marginTop =
        this.accDiv(this.accSub(containerHeight, graphHeight), 2) + "px";
      container.style.backgroundColor = tempSize.bgColor;
      if (tempSize.grid) {
        //是否显示网格
        this.showGrid = true;
      } else {
        this.showGrid = false;
      }
      // debugger;
      if (tempSize.imageUrl != "" && tempSize.imageUrl != undefined) {
        //var tempArray = tempSize.imageUrl.split("//");
        //var target = tempArray[1].split("/")[1];
        var imageURL =
          "http://localhost:5000/script/mxgraph-source/images/images/gradient_background.jpg";
        // window.location.protocol +
        // "//" +
        // window.location.hostname +
        // ":" +
        // window.location.port +
        // "/" +
        // target;
        // debugger;
        console.log("原始URL" + tempSize.imageUrl);
        this.showGrid = false;
        this.m_graph.setBackgroundImage(
          new mxImage(imageURL, graphWidth, graphHeight)
        );
        console.log(imageURL);
      }
    },
    handleDbClick() {
      this.m_graph.addListener(mxEvent.DOUBLE_CLICK, function(sender, evt) {
        //元素双击事件
      });
    },
    handleClick() {
      var self = this;
      this.m_graph.addListener(mxEvent.CLICK, function(sender, evt) {
        //元素单击事件
        var cell = self.m_graph.getSelectionModel(); //获取当前选择的元素的所有信息
        if (cell.cells.length < 1) {
          return;
        }
        self.setItemPoeperty(cell);
        if (cell.cells.length > 1) {
          self.seletChange = true;
          this.$emit("selectChange", 1);
        }

        console.log("鼠标事件!");
      });
    },
    handelResizeCell() {
      var self = this;
      this.m_graph.addListener(mxEvent.RESIZE_CELLS, function(sender, evt) {
        //元素大小改变事件
        var cell = self.m_graph.getSelectionModel(); //获取当前选择的元素的所有信息
        if (cell.cells.length < 1) {
          return;
        }
      });
    },
    handelMove() {
      this.m_graph.addListener(mxEvent.CELLS_MOVED, function(sender, evt) {
        //移动事件
      });
    },
    handleAddVertex() {
      this.m_graph.addListener(mxEvent.CELLS_ADDED, function(sender, evt) {});
    },
    handleRemove() {
      this.m_graph.addListener(mxEvent.REMOVE_CELLS, function(sender, evt) {
        //删除事件的拦截，应该还是需要重写remove函数，因为很多事件操作里面用到了这个，单独拦截的话，可能会不全面
        // console.log("删除元素!");
      });
    },

    bindEvent() {
      //给编辑器绑定事件

      this.handleDbClick();
      this.handleClick();
      this.handelResizeCell();
      this.handelMove();
      this.handleRemove();
    },
    setItemPoeperty(cell) {
      this.$nextTick(() => {
        this.$emit("ExchangePorperty", cell.cells, this.m_graph);
      });
    },

    setCellPorperty(data, type) {
      //接收参数面板传递过来的数据，对选中的元素进行处理
      if (this.m_graph == undefined) return;
      var cells = this.m_graph.getSelectionCells();
      var vertex = cells[0];
      this.setPorpertyByID(vertex, data);
    },
    setPorpertyByID(cell, data) {
      if (data.type == "grid") {
        this._setGraphSize(data.data);
        return;
      }
      if (data.cellType != undefined && data.cellType != cell.cellType) {
        //如果面板元素类型和画布不一致，则不允许对画布元素进行赋值
        return;
      }
      if (data.type == "Arrange") {
        this._setVertexArrange(data.data);
        this.$emit("selectChange", 0);
      }
      if (data.type == "Style") {
        this._setVertexStyle(data.data);
        this.$emit("selectChange", 0);
      }
      if (data.type == "Text") {
        this._setVertexTextStyle(data.data);
        this.$emit("selectChange", 0);
      }

      if (data.type == "EditStyle") {
        this._setStyleByEditStyle(data.data);
        this.$emit("selectChange", 0);
      }
    },
    _setStyleByEditStyle(style) {
      var self = this;
      var model = self.m_graph.getSelectionCells();
      if (model.length < 1) return; //没有选中任何元素的时候，则返回，什么都不做
      var cell = model[0];
      cell.setStyle(style);
      this.handleRefresh();
    },
    _setVertexArrange(data) {
      var self = this;
      var model = self.m_graph.getSelectionCells();
      if (model.length < 1) return; //没有选中任何元素的时候，则返回，什么都不做
      var cell = model[0];
      cell.geometry.x = data.x;
      cell.geometry.y = data.y;
      cell.geometry.width = data.w;
      cell.geometry.height = data.h;
      this.m_graph.setCellStyles(mxConstants.STYLE_ROTATION, data.Angle, [
        cell,
      ]);
      this.handleRefresh();
    },
    _setVertexStyle(data) {
      //设置元素样式
      var self = this;
      var model = self.m_graph.getSelectionCells();
      if (model.length < 1) return; //没有选中任何元素的时候，则返回，什么都不做
      var cell = model[0];
      this.m_graph.setCellStyles(mxConstants.STYLE_FILLCOLOR, data.fillColor, [
        cell,
      ]);

      this.m_graph.setCellStyles(
        mxConstants.STYLE_GRADIENTCOLOR,
        data.gradientColor,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_GRADIENT_DIRECTION,
        data.direct,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_STROKECOLOR,
        data.strokeWidth == "0" ? "#ffffff" : data.lineColor,
        [cell]
      );
      this.setLineType(data.lineType, cell);
      this.m_graph.setCellStyles(mxConstants.STYLE_OPACITY, data.opacity, [
        cell,
      ]);
      var isShadow = data.shadow == true ? 1 : 0;
      this.m_graph.setCellStyles(mxConstants.STYLE_SHADOW, isShadow, [cell]);
      var glass = data.glass == true ? 1 : 0;
      this.m_graph.setCellStyles(mxConstants.STYLE_GLASS, glass, [cell]);
      var ifRound = data.rounded == true ? 1 : 0;
      this.m_graph.setCellStyles(mxConstants.STYLE_ROUNDED, ifRound, [cell]);
      this.m_graph.setCellStyles(
        mxConstants.STYLE_STROKEWIDTH,
        parseInt(data.strokeWidth),
        [cell]
      );
      if (data.imageUrl != "" && data.imageUrl != undefined) {
        // debugger;
        this.m_graph.setCellStyles(mxConstants.STYLE_IMAGE, data.imageUrl, [
          cell,
        ]);
        // cell.setValue("<img src=" + data.imageUrl + ">");
      }

      this.handleRefresh();
    },
    setLineType(type, cell) {
      switch (type) {
        case 1: {
          //STYLE_DASHED
          this.m_graph.setCellStyles(mxConstants.STYLE_DASHED, 0, [cell]);
          break;
        }
        case 2: {
          this.m_graph.setCellStyles(mxConstants.STYLE_DASHED, 1, [cell]);
          break;
        }
        case 3: {
          this.m_graph.setCellStyles(mxConstants.STYLE_DASHED, 1, [cell]);
          this.m_graph.setCellStyles(mxConstants.STYLE_DASH_PATTERN, "1 1", [
            cell,
          ]);
          break;
        }
        case 4: {
          this.m_graph.setCellStyles(mxConstants.STYLE_DASHED, 1, [cell]);
          this.m_graph.setCellStyles(mxConstants.STYLE_DASH_PATTERN, "1 2", [
            cell,
          ]);
          break;
        }
        case 5: {
          this.m_graph.setCellStyles(mxConstants.STYLE_DASHED, 1, [cell]);
          this.m_graph.setCellStyles(mxConstants.STYLE_DASH_PATTERN, "1 4", [
            cell,
          ]);
          break;
        }
      }
    },
    _setVertexTextStyle(data) {
      var self = this;
      var model = self.m_graph.getSelectionCells();
      if (model.length < 1) return; //没有选中任何元素的时候，则返回，什么都不做
      var cell = model[0];
      this.m_graph.setCellStyles(mxConstants.STYLE_FONTFAMILY, data.font, [
        cell,
      ]);
      this.m_graph.setCellStyles(mxConstants.STYLE_FONTSIZE, data.fontSize, [
        cell,
      ]);
      this.m_graph.setCellStyles(mxConstants.STYLE_FONTSTYLE, data.fontStyle, [
        cell,
      ]);
      var showHor = data.showHor == true ? 1 : 0;
      this.m_graph.setCellStyles(mxConstants.STYLE_HORIZONTAL, showHor, [cell]);
      this.m_graph.setCellStyles(mxConstants.STYLE_ALIGN, data.graphStyle, [
        cell,
      ]);
      this.m_graph.setCellStyles(
        mxConstants.STYLE_VERTICAL_ALIGN,
        data.graphPositi,
        [cell]
      );
      this._setLabelPosition(data, cell);
      this.m_graph.setCellStyles(mxConstants.STYLE_FONTCOLOR, data.textColor, [
        cell,
      ]);
      this.m_graph.setCellStyles(
        mxConstants.STYLE_LABEL_BACKGROUNDCOLOR,
        data.textBGColor,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_LABEL_BORDERCOLOR,
        data.textBorderColor,
        [cell]
      ); //
      var wordWrap = data.textWordWrap == true ? "wrap" : "nowrap";
      this.m_graph.setCellStyles(mxConstants.STYLE_WHITE_SPACE, wordWrap, [
        cell,
      ]);
      this.m_graph.setCellStyles(
        mxConstants.STYLE_TEXT_OPACITY,
        data.textOpacity,
        [cell]
      );
      this.m_graph.setCellStyles(mxConstants.STYLE_SPACING, data.textPadding, [
        cell,
      ]);
      this.m_graph.setCellStyles(
        mxConstants.STYLE_SPACING_TOP,
        data.textPaddingT,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_SPACING_LEFT,
        data.textPaddingL,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_SPACING_BOTTOM,
        data.textPaddingB,
        [cell]
      );
      this.m_graph.setCellStyles(
        mxConstants.STYLE_SPACING_RIGHT,
        data.textPaddingR,
        [cell]
      );
      if (
        cell.cellType != "qrCode" &&
        cell.cellType != "barCode" &&
        cell.selectCellType != "image"
      ) {
        cell.setValue(data.Text);
      }
      // debugger;
      if (cell.cellType == "qrCode") {
        this._setQRImage(cell, data);
      }

      if (cell.cellType == "barCode") {
        this._setBarCodeImage(cell, data);
      }
      this.handleRefresh();
    },
    _setQRImage(cell, data) {
      var canvas = document.getElementById("qrcode");
      if (data.BarcodeText == "123456789") {
        data.BarcodeText = "条码";
      }
      QRCode.toCanvas(canvas, data.BarcodeText, function(error) {
        if (error) console.error(error);
        console.log("success!");
      });
      var IMAGE_TYPE = "image/gif";
      var imageUrl = canvas.toDataURL(IMAGE_TYPE);
      this.qrCodeUrl = imageUrl;
      cell.setValue("<img src=" + this.qrCodeUrl + ">");
      cell.codeType = data.codeType;
      cell.ifFixText = data.ifFixText;
      cell.geometry.width = canvas.width;
      cell.geometry.height = canvas.height;
      this.handleRefresh();
    },
    _setBarCodeImage(cell, data) {
      if (data.BarcodeText == "条码") {
        data.BarcodeText = "123456789";
      }
      JsBarcode("#barcode", data.BarcodeText, {
        format: data.codeType,
        // lineColor: "#fff",
        width: 1,
        height: 55,
        displayValue: true,
      });
      var canvas = document.getElementById("barcode");
      var IMAGE_TYPE = "image/gif";
      var imageUrl = canvas.toDataURL(IMAGE_TYPE);
      this.barCodeUrl = imageUrl;
      cell.setValue("<img src=" + this.barCodeUrl + ">");
      cell.codeType = data.codeType;
      cell.ifFixText = data.ifFixText;
      this.handleRefresh();
    },
    _setLabelPosition(data, cell) {
      switch (data.textPositi) {
        case "TTL": {
          this.m_graph.setCellStyles(mxConstants.STYLE_LABEL_POSITION, "left", [
            cell,
          ]);
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "top",
            [cell]
          );
          break;
        }
        case "TTC": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "center",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "top",
            [cell]
          );
          break;
        }
        case "TTR": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "right",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "top",
            [cell]
          );
          break;
        }
        case "CTL": {
          this.m_graph.setCellStyles(mxConstants.STYLE_LABEL_POSITION, "left", [
            cell,
          ]);
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "middle",
            [cell]
          );
          break;
        }
        case "CTC": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "center",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "middle",
            [cell]
          );
          break;
        }
        case "CTR": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "right",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "middle",
            [cell]
          );
          break;
        }
        case "BTL": {
          this.m_graph.setCellStyles(mxConstants.STYLE_LABEL_POSITION, "left", [
            cell,
          ]);
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "bottom",
            [cell]
          );
          break;
        }
        case "BTC": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "center",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "bottom",
            [cell]
          );
          break;
        }
        case "BTR": {
          this.m_graph.setCellStyles(
            mxConstants.STYLE_LABEL_POSITION,
            "right",
            [cell]
          );
          this.m_graph.setCellStyles(
            mxConstants.STYLE_VERTICAL_LABEL_POSITION,
            "bottom",
            [cell]
          );
          break;
        }
      }
    },
    reWriteKeyHandle() {
      var self = this;
      //重写键盘事件
      mxKeyHandler.prototype.getFunction = function(evt) {
        //var model = self.m_graph.getSelectionCells();
        //var cell = model[0];
        var control =
          mxEvent.isControlDown(evt) || (mxClient.IS_MAC && evt.metaKey)
            ? this.controlKeys[evt.keyCode]
            : this.normalKeys[evt.keyCode];
        if (
          evt.key == "ArrowLeft" ||
          evt.key == "ArrowRight" ||
          evt.key == "ArrowDown" ||
          evt.key == "ArrowUp"
        ) {
          self.changeCellsGemoetry(control, evt);
        } else {
          return control;
        }
      };
    },
    changeCellsGemoetry(control, evt) {
      var self = this;
      if (evt.key == "ArrowLeft") {
        if (evt.ctrlKey == false && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("x", -1);
        } else if (evt.ctrlKey == true && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("x", -10);
        } else if (evt.ctrlKey == false && evt.shiftKey == true) {
          self.moveCellsOrChangeSize("width", -1);
        } else {
          return control;
        }
      }
      if (evt.key == "ArrowRight") {
        if (evt.ctrlKey == false && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("x", 1);
        } else if (evt.ctrlKey == true && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("x", 10);
        } else if (evt.ctrlKey == false && evt.shiftKey == true) {
          self.moveCellsOrChangeSize("width", 1);
        } else {
          return control;
        }
      }
      if (evt.key == "ArrowDown") {
        if (evt.ctrlKey == false && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("y", 1);
        } else if (evt.ctrlKey == true && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("y", 10);
        } else if (evt.ctrlKey == false && evt.shiftKey == true) {
          self.moveCellsOrChangeSize("height", 1);
        } else {
          return control;
        }
      }
      if (evt.key == "ArrowUp") {
        if (evt.ctrlKey == false && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("y", -1);
        } else if (evt.ctrlKey == true && evt.shiftKey == false) {
          self.moveCellsOrChangeSize("y", -10);
        } else if (evt.ctrlKey == false && evt.shiftKey == true) {
          self.moveCellsOrChangeSize("height", -1);
        } else {
          return control;
        }
      }
    },
    moveCellsOrChangeSize(type, step) {
      var model = this.m_graph.getSelectionModel();
      var cells = model.cells;
      // var graph = this.m_graph;
      for (var i = 0; i < cells.length; i++) {
        cells[i].geometry[type] += step;
      }
      this.m_graph.refresh();
    },
    _initContainerSize() {
      var winHeight = window.innerHeight;
      //var temp = $("#graph_container");
      this.containerHeight = winHeight - 120; //$("#graph_container")[0].clientHeight;
    },
    _initQRCode() {
      //动态生成二维码携带queryDetail生成二维码
      //var QueryDetail = "http://14.29.255.162:8990/index.html#/download";
      var QueryDetail = "条码";
      var canvas = document.getElementById("qrcode");
      QRCode.toCanvas(canvas, QueryDetail, function(error) {
        if (error) console.error(error);
        console.log("success!");
      });
      var IMAGE_TYPE = "image/gif";
      var imageUrl = canvas.toDataURL(IMAGE_TYPE);
      this.qrCodeUrl = imageUrl;
    },
    _initBarCode() {
      //动态生成一维码携带queryDetail生成二维码
      // $("#barcode").JsBarcode(QueryDetail);
      JsBarcode("#barcode", "123456789", {
        format: "CODE128",
        // lineColor: "#fff",
        width: 1,
        height: 55,
        displayValue: true,
      });
      var canvas = document.getElementById("barcode");
      var IMAGE_TYPE = "image/gif";
      var imageUrl = canvas.toDataURL(IMAGE_TYPE);
      this.barCodeUrl = imageUrl;
    },
  },
  created() {
    var self = this;
    this.porperEvent.$on("porpertyChange", (formData) => {
      //从事件总线接收事件
      self.setCellPorperty(formData);
    });
  },
  beforeMount() {},
  mounted() {
    if (!mxClient.isBrowserSupported()) {
      //验证浏览器是否支持绘图
      mxUtils.error("当前浏览器不支持", 200, false);
    } else {
      this._initGraph();
      this._initContainerSize();
      this._initQRCode(); //初始化二维码
      this._initBarCode(); //初始化一维码
      this.reWriteKeyHandle(); //重写键盘响应函数
      this.bindEvent(); //事件绑定函数
    }
  },
  beforeDestroy() {
    //组件销毁的时候，清掉相关实例
    this.m_graph.destroy();
    this.m_editor.destroy();
    this.m_toolbar.destroy();
    //this.m_view.destroy();
  },
};
</script>

<style scoped>
#graph_container {
  /* width: 200px;
  height: 100px;  */
  position: relative;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100mm;
  height: 70mm;
}
#graph_main {
  /* 画布外容器 */
  background-color: lightgrey;
  overflow: auto;
}
.backGroundImage {
  box-shadow: #666 0px 0px 10px;
  background: url("../../assets/mxgraph-source/images/images/grid.gif");
}
.backGroundNone {
  background: none;
  /* box-shadow: #666 0px 0px 10px; */
}
</style>
